
  import {prepareImageUrl} from '@/helper/ImageHelper';

  export default {
    name: 'WikiCard',
    filters: {
      truncate(string, value) {
        return string.length > value
          ? string.substring(0, value) + '…'
          : string;
      },
    },
    props: {
      wiki: {
        type: Object,
        default: () => {},
      },
      fillHeight: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    serverCacheKey: function (props) {
      // return a key based on the props. in this case, we're using the `id` prop:
      return 'wiki-card-' + props.wiki.id;
    },
    data() {
      return {
        scope: process.env.SCOPE_CANDIDATE,
        imageUrl: process.env.NUXT_ENV_FALLBACK_IMAGE_STATIC,
      };
    },
    created() {
      if (this.$route.fullPath.includes('/recruiting')) {
        this.scope = process.env.SCOPE_ORGANIZATION;
      }

      if (this.wiki.cover[0]) {
        this.imageUrl = prepareImageUrl(this.wiki.cover[0].url);
      }
    },
  };
